import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-2006"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M1 6.368a2.183 2.183 0 1 0 4.368 0c0-1.207-2.184-4.367-2.184-4.367S1 5.161 1 6.368zm4.816 5.449a2.183 2.183 0 1 0 4.368 0C10.184 10.61 8 7.449 8 7.449s-2.184 3.161-2.184 4.368zm7-9.816s-2.184 3.161-2.184 4.368A2.183 2.183 0 1 0 15 6.368c0-1.208-2.184-4.367-2.184-4.367z",
  style: {"fill-rule":"evenodd","clip-rule":"evenodd"}
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }